<!--
 * @Description: 二次确认支付。线上需要短信确认，线下不需要使用短信，直接二次确认
 * @Date: 2020-12-11 16:43:18
-->
<template>
  <div class="sms" v-loading="phoneLoading">
    <template v-if="payType === 1">
      <p>将下发短信验证码至您的手机：{{ phone | transPhone }}</p>
      <div class="sms__content">
        <el-input :maxlength="4" v-model="verifyCode" />
        <el-button
          :loading="btnLoading"
          @click="getVer"
          style="margin-left:10px"
        >
          {{ btnText }}
        </el-button>
      </div>
    </template>
    <p style="margin-bottom:30px;font-size:15px" v-else>是否确认支付</p>
    <div class="xrk-dialog__btns">
      <el-button @click="cancel">返回</el-button>
      <el-button
        type="primary"
        @click="confirm"
        style="margin-left: 80px"
        :loading="confirmLoading"
      >
        确认
      </el-button>
    </div>
  </div>
</template>

<script>
import { csoCustomerOrder, bfAccount, isOverrunQuota } from '@/api/ajax';
import {
  isRevokePeople,
  useQuotaDialog,
  imitateAjax
} from '@/page/settlementCenter/utils';
import { createMsgbox } from '../../utils/create-msgbox';

export default {
  props: {
    csoOrderIds: String,
    csoCustomOrderIds: {
      type: [Number, String],
      default: '',
      required: false
    },
    csoOrderServicesIds: {
      type: [Number, String],
      default: '',
      required: false
    },
    comprehensiveOrderIds: {
      type: [Number, String],
      default: '',
      required: false
    },
    csoBusServicesIds: {
      type: [Number, String],
      default: '',
      required: false
    },
    authOrderIds: {
      type: [Number, String],
      default: '',
      required: false
    },
    payPassagewayCode: String
  },
  data() {
    return {
      phone: '',
      verifyCode: '',
      btnText: '获取验证码',
      timer: null,
      phoneLoading: true,
      confirmLoading: false,
      btnLoading: false
    };
  },

  computed: {
    payType() {
      return this.$store.state.orderMgmt.payType;
    }
  },
  methods: {
    async getVer() {
      //重新发送
      if (!/^1[0-9]{10}$/.test(this.phone)) {
        this.$message({
          type: 'error',
          message: '请填写正确手机号'
        });
      } else {
        if (this.btnText === '获取验证码' || this.btnText === '重新发送') {
          try {
            this.btnLoading = true;
            await csoCustomerOrder.sendOrderPayMsgV2({
              phone: this.phone,
              payPassagewayCode: this.payPassagewayCode
            });
            this.btnLoading = false;
            this.setInter(60);
            this.$message({
              type: 'success',
              message: '短信已发送成功，请注意接收~'
            });
          } catch (err) {
            this.btnLoading = false;
            console.error(err);
          }
        }
      }
    },
    setInter(time = 60) {
      let interFn = () => {
        if (this.btnText > 0) {
          this.btnText -= 1;
        } else {
          this.btnText = '重新发送';
          clearInterval(this.timer);
        }
      };
      if (time > 0) {
        this.btnText = time;
        this.timer = setInterval(interFn, 1000);
      } else {
        this.btnText = '重新发送';
        interFn();
      }
    },
    cancel() {
      this.$xrkDialog.remove();
    },
    async confirm() {
      // let csoCustomOrderIdsArr = [];
      // let csoOrderServicesIdsArr = [];
      // let comprehensiveOrderIdsArr = [];
      // let authOrderIdsArr = [];
      // this.selection.map(item => {
      //   if (item.priceType === 1) {
      //     csoCustomOrderIdsArr.push(item.id);
      //   } else if (item.priceType === 2) {
      //     csoOrderServicesIdsArr.push(item.id);
      //   } else if (item.priceType === 3) {
      //     authOrderIdsArr.push(item.id);
      //   } else if (item.priceType === 4) {
      //     comprehensiveOrderIdsArr.push(item.id);
      //   }
      // });
      // 线下不需要使用短信，直接二次确认
      if ((this.verifyCode && this.phone) || this.payType === 2) {
        this.confirmLoading = true;
        // 只有组合订单执行
        if (this.csoCustomOrderIds) {
          try {
            // 是否退出
            await isRevokePeople(this.csoCustomOrderIds, false);
            // 是否超额
            await isOverrunQuota({
              csoCustomOrderIds: this.csoCustomOrderIds
            });
          } catch (err) {
            const { code, data } = err;
            // 超额
            if (+code === -1) {
              useQuotaDialog.call(this, {}, imitateAjax(data));
            }
            this.confirmLoading = false;
            return;
          }
        }

        try {
          const checkRes = await csoCustomerOrder.submitPayOrderV2({
            verifyCode: this.verifyCode,
            csoCustomOrderIds: this.csoCustomOrderIds,
            csoOrderServicesIds: this.csoOrderServicesIds,
            comprehensiveOrderIds: this.comprehensiveOrderIds,
            authOrderIds: this.authOrderIds,
            csoBusServicesIds: this.csoBusServicesIds,
            btnLoading: true,
            payType: this.$store.state.orderMgmt.payType
          });

          if (createMsgbox(this, checkRes)) return;
        } catch (err) {
          const { data, code } = err;
          // 超额
          if (+code === -1) {
            useQuotaDialog.call(this, {}, imitateAjax(data));
          }
          return;
        } finally {
          this.confirmLoading = false;
        }
        this.$message({
          type: 'success',
          message: '操作成功'
        });

        this.$xrkDialog.clear();
        location.reload();
      }
    }
  },
  async created() {
    // 只有线上校验开户信息
    if (this.payType === 1) {
      const {
        pdata: { transactorPhone }
      } = await bfAccount({ payPassagewayCode: this.payPassagewayCode });
      this.phone = transactorPhone;
    }
    this.phoneLoading = false;
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  }
};
</script>

<style>
.checkMessage {
  width: 650px !important;
}
</style>
<style scoped lang="scss">
.sms {
  &__content {
    margin-top: 15px;
    display: flex;
  }
}
</style>
